import { useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';
import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';

const useStyles = createStyles(
  (theme: typeof defaultTheme) => ({
    root: {
      padding: '0.75rem 0 0.4rem 0',
      margin: '0 2rem',
      fontSize: '1rem',
      lineHeight: '1.35',
      color: theme.palette.text.dark,
      whiteSpace: 'nowrap',
      position: 'relative',
      '&:hover': {
        color: theme.palette.text.dark,
        textDecoration: 'none',
      },
      '&:first-letter': {
        textTransform: 'capitalize',
      },
    },
    active: {
      color: theme.palette.text.dark,
      fontWeight: 'bold',
      '&::before': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '1px',
        backgroundColor: theme.palette.secondary.default,
        borderRadius: '20px',
        position: 'absolute',
        left: 0,
        bottom: '-1px',
      },
    },
  }),
  { name: 'Tab' }
);

function reinitializeIframeSrc() {
  const frame = document.querySelector('iframe');
  if (frame) {
    // eslint-disable-next-line no-self-assign
    frame.src = frame.src;
  }
}

interface NavTabProps {
  to: string;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

const NavTab = ({ to, className, children }: NavTabProps) => {
  const classes = useStyles();
  const location = useLocation();
  const locationState = location.state || {};

  const handleClick = useCallback(() => {
    if (location.pathname.includes(to)) {
      reinitializeIframeSrc();
    }
  }, []);

  return (
    <NavLink
      activeClassName={classes.active}
      to={{
        pathname: to,
        state: { ...locationState },
      }}
      className={cn(classes.root, className)}
      onClick={handleClick}
    >
      {children}
    </NavLink>
  );
};

export default NavTab;
